import Input from "../Core/Fields/Floating/Input";

const ReadOnlyField = ({  
  read, 
  children, 
  attributes
}) => {
  return (
    <div className='mb-3' >
         {read ? <Input
              id="orderNo"
              label={attributes.label}
              readOnly
              value={attributes.value}
              style={{ height: '30px' }}
            /> : children}   
    </div>
  );
};

export default ReadOnlyField;